import { onBeforeUnmount, ref } from 'vue'

import { useNavigation } from './useNavigation'

export function useMegaMenu() {
  const {
    setActiveMenu,
    clearActiveMenu,
    activeMenu,
    isMenuActive,
    isActivePage,
  } = useNavigation()

  const timeout = ref()

  onBeforeUnmount(() => {
    clearTimeout(timeout.value)
  })
  function showMenu(id: number) {
    clearTimeout(timeout.value)
    timeout.value = setTimeout(() => {
      setActiveMenu(id)
    }, 150)
  }

  function hideMenu() {
    clearTimeout(timeout.value)
    timeout.value = setTimeout(() => {
      clearActiveMenu()
    }, 150)
  }

  return {
    showMenu,
    hideMenu,
    activeMenu,
    isMenuActive,
    isActivePage,
  }
}
